module.exports = __webpack_public_path__ + "99fe088d58b2ec011c580e0b342c4a8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-12-harrison/diary.jpg
// module id = 660
// module chunks = 0